import React from 'react';
import ItemReportFunctional from './components/item-report-list-functional';
import './item-report.scss';

const ItemReport = () => {
	return <ItemReportFunctional />;
};

export default ItemReport;
